import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ_ITEMS = [
  {
    id: 'without-saving',
    question: 'How do I message someone on WhatsApp without saving their number?',
    answer:
      'Pick your country code, enter their phone number, and tap Open in WhatsApp. You’ll go straight to a chat in WhatsApp—nothing is saved in Text Away or added to your contacts.',
  },
  {
    id: 'country-code',
    question: 'Do I need to include the country code?',
    answer:
      'Yes. Choose the country in the code dropdown, then enter the local number. For Indonesian numbers you can start with 0 (e.g. 0812…)—we’ll format it correctly.',
  },
  {
    id: 'free-privacy',
    question: 'Is Text Away free? Do you store my number?',
    answer:
      'It’s free. We don’t store numbers you enter; they’re only used to open WhatsApp’s official chat link. See the disclaimer in the footer for privacy details.',
  },
  {
    id: 'not-working',
    question: 'Why didn’t WhatsApp open or say the number isn’t on WhatsApp?',
    answer:
      'The number may be wrong, missing a digit, or not registered on WhatsApp. Double-check the country code and number, then try again.',
  },
  {
    id: 'install',
    question: 'Can I install Text Away on my phone?',
    answer: (
      <>
        Yes. On <strong>iPhone or iPad</strong>, use Safari → Share → Add to Home
        Screen. On <strong>Android</strong>, use your browser’s install or Add to
        home screen option. Tap Help ? above for a full guide.
      </>
    ),
  },
];

export default function FaqSection() {
  return (
    <Box
      component="section"
      aria-labelledby="faq-heading"
      sx={{ width: '100%', mt: 3, mb: 2, textAlign: 'left' }}
    >
      <Typography
        id="faq-heading"
        component="h2"
        variant="h6"
        sx={{ mb: 1, textAlign: 'center', fontWeight: 600 }}
      >
        Frequently asked questions
      </Typography>
      {FAQ_ITEMS.map((item) => (
        <Accordion
          key={item.id}
          disableGutters
          elevation={0}
          square
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '&:before': { display: 'none' },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${item.id}-content`}
            id={`${item.id}-header`}
            sx={{ minHeight: 48, px: 0 }}
          >
            <Typography variant="subtitle2" component="span" fontWeight={500}>
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0, pt: 0, pb: 2 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              component="div"
              sx={{ lineHeight: 1.6 }}
            >
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
